import React from 'react';
import './NotionDataTable.css';

const EmptyTable = () => {
  return (
    <div className="notion-data-container">
      <div className="empty-state">
        <p>📭 База данных пуста</p>
      </div>
    </div>
  );
};

export default EmptyTable;

